var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showAllUsers ||
    _vm.user.is_internal ||
    _vm.user.is_admin ||
    _vm.user.is_master
    ? _c(
        "span",
        [
          _c("emc-table-icon", {
            attrs: {
              disabled: _vm.disabled,
              loading: _vm.loading,
              icon: "mdi-history",
              color: _vm.color,
              "tool-tip": _vm.toolTip,
            },
            on: { click: _vm.open },
          }),
          _c("emc-modal-form", {
            attrs: {
              title: "Logs de auditoria",
              icon: "mdi-history",
              maxWidth: "90%",
              show: _vm.dialog,
            },
            on: {
              "update:show": function ($event) {
                _vm.dialog = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "form",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { outlined: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "py-2" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-subtitle-2" },
                                        [_vm._v("Registros")]
                                      ),
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            disabled: _vm.loading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              $event.stopPropagation()
                                              return _vm.fetchLogs.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [_c("v-icon", [_vm._v("mdi-refresh")])],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-card-text",
                                    { staticClass: "py-2" },
                                    [
                                      _vm.errorMessage
                                        ? _c(
                                            "v-alert",
                                            {
                                              attrs: {
                                                type: "error",
                                                dense: "",
                                                text: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.errorMessage) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c("v-data-table", {
                                        staticClass: "elevation-0",
                                        attrs: {
                                          headers: _vm.headers,
                                          items: _vm.logs,
                                          loading: _vm.loading,
                                          "items-per-page": 10,
                                          dense: "",
                                          "fixed-header": "",
                                          height: "360",
                                        },
                                        on: { "click:row": _vm.selectLog },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item.created_at",
                                              fn: function ({ item }) {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("dateTime")(
                                                          item.created_at
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              },
                                            },
                                            {
                                              key: "no-data",
                                              fn: function () {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Sem logs para este registro."
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3685496155
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { outlined: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "py-2" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-subtitle-2" },
                                        [_vm._v("Alterações")]
                                      ),
                                      _c("v-spacer"),
                                      _vm.selected && _vm.selected.created_at
                                        ? _c("small", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("dateTime")(
                                                    _vm.selected.created_at
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-card-text",
                                    {
                                      staticClass: "py-2",
                                      staticStyle: { "min-height": "360px" },
                                    },
                                    [
                                      _vm.payloadLoading
                                        ? _c(
                                            "div",
                                            { staticClass: "text-center py-6" },
                                            [
                                              _c("v-progress-circular", {
                                                attrs: {
                                                  indeterminate: "",
                                                  color: "primary",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm.changes
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "audit-table-scroll",
                                            },
                                            [
                                              _c(
                                                "v-simple-table",
                                                { attrs: { dense: "" } },
                                                [
                                                  _c("thead", [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v("Campo"),
                                                      ]),
                                                      _c("th", [
                                                        _vm._v("Antes"),
                                                      ]),
                                                      _c("th", [
                                                        _vm._v("Depois"),
                                                      ]),
                                                    ]),
                                                  ]),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      _vm.changesRows,
                                                      function (row) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key: row.key,
                                                            class: row.changed
                                                              ? "audit-row-changed"
                                                              : "",
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text--secondary",
                                                                staticStyle: {
                                                                  "vertical-align":
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c("code", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      row.key
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticStyle: {
                                                                  "vertical-align":
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "pre",
                                                                  {
                                                                    staticClass:
                                                                      "audit-pre",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatValue(
                                                                          row.old
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticStyle: {
                                                                  "vertical-align":
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "pre",
                                                                  {
                                                                    staticClass:
                                                                      "audit-pre",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.formatValue(
                                                                          row.new
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "text--secondary" },
                                            [
                                              _vm._v(
                                                " Clique em um registro para ver as alterações. "
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3196052065
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }